<template>
  <div>
    <div class="func-bar">
      <FileUploader style="float: left;margin:10px"></FileUploader>
      <XlsUploader style="float: left;margin:10px"></XlsUploader>
      <EditableTable
          :data="updateData"
          :column-configs="updateDataColumnConfig"
          style="width:50%;clear:left;text-align: center"
      ></EditableTable>
    </div>
    <br>
    <EditableTable
        :data="data"
        :columnConfigs="columnConfigs"
        style="min-width: 1000px;"
        height="73vh"
    ></EditableTable>
    <hr v-if="isLastPage">
  </div>
</template>

<script>
import EditableTable from "@/components/EditableTable";
import FileUploader from "@/components/FileUploader";
import XlsUploader from "@/components/XlsUploader";
import {InfiniteScroller} from "@/components/infiniteScroller";
import {storeList} from "@/api";

export default {
  name: "Store",
  components: {EditableTable, FileUploader, XlsUploader},
  data() {
    return {
      infiniteScroller: null,
      updateData: [{VER: '', AMOUNT: 0, DATE: '',}],
      fetchedPages: 0,
      fetchingPage: false,
      dd: null,
      isLastPage: false,
      data: [],
      columnConfigs: [
        {name: 'PID', alias: '編號', editable: false, needLevel: 0, width: '8%'},
        {name: 'PIC', alias: '圖片', editable: false, needLevel: 0, width: '', fixWidth: '100px', align: 'center'},
        {name: 'CATEGORY', alias: '父類別', editable: false, needLevel: 0, width: '15%'},
        {name: 'SUBTYPE', alias: '子類別', editable: false, needLevel: 0, width: '17%'},
        {name: 'PNAME', alias: '產品名稱', editable: false, needLevel: 0, width: '20%'},
        {name: 'VIP1', alias: '價格 A', editable: false, needLevel: 0, width: '10%', align: 'center'},
        {name: 'VIP2', alias: '價格 G', editable: false, needLevel: 0, width: '10%', align: 'center'},
        {name: 'SPEC', alias: '規格', editable: false, needLevel: 0, width: '10%'},
        {name: 'TAG', alias: '標籤', editable: false, needLevel: 0, width: '10%'},
        {name: 'DESC', alias: '說明', editable: false, needLevel: 0, width: '25%'},
      ],
      updateDataColumnConfig: [
        {name: 'VER', alias: '版本號', editable: false, needLevel: 0, width: '20%'},
        {name: 'AMOUNT', alias: '資料總筆數', editable: false, needLevel: 0, width: '30%'},
        {name: 'DATE', alias: '最近更新時間', editable: false, needLevel: 0, width: '50%'},
      ]
    }
  },
  methods: {
    callback({LIST, VER, AMOUNT, DATE}) {
      if (LIST.length === 0) {
        return true
      } else {
        this.updateData = [{VER, AMOUNT, DATE}]
        this.data = [...this.data, ...LIST]
        return false
      }
    }
  },
  mounted() {
    const targetNode = document.getElementsByClassName('el-table__body-wrapper')[1]
    this.infiniteScroller = new InfiniteScroller(storeList, this.callback, targetNode, 200, 25, 600)
    this.infiniteScroller.start()
  },
  beforeDestroy() {
    this.infiniteScroller.stop()
  }
}
</script>

<style scoped>
img {
  max-width: 100%;
  margin: auto;
}

.func-bar > * {
  display: inline-block;
}

</style>
